import React from "react";

const Title = ({ text }) => {
  return (
    <h2 
      className="font-manrope font-extrabold text-[12px] leading-[16px] tracking-[5%] uppercase text-[#717171]"
      style={{
        fontFamily: 'Manrope',
        fontWeight: 800,
        fontStyle: 'normal',
        fontSize: '16p9x',
        lineHeight: '16px',
        letterSpacing: '5%',
        textTransform: 'uppercase'
      }}
    >
      {text}
    </h2>
  );
};

export default Title;
